import { useGetBookingCount } from 'api-hooks/booking/query';
import Stack from 'components/commons/stack';
import { TabItem, Tabs } from 'components/widgets/tabs';
import { useAuthorization, AuthType } from 'hooks/use-authorization';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import BookingTemplate from './booking-template';
import { Section, SectionContent, TitleText } from './style';

const contents = ['active', 'pending', 'history', 'refund'] as const;

export default function CheckBooking() {
  const { t } = useTranslation();
  const { data, refetch } = useGetBookingCount();
  const { query } = useRouter();

  useAuthorization({
    type: AuthType.Authenticated,
  });

  return (
    <>
      <Section>
        <SectionContent>
          <TitleText>{t('common:check_booking')}</TitleText>
          <Tabs
            aria-label="check-booking"
            tabMinWidth={0}
            tabPanelCss={{ padding: 0, pt: 16 }}
            defaultActiveKey={query.type ? query.type.toString()! : 'active'}
            onChangeTab={() => refetch()}
          >
            {contents.map((item) => {
              return (
                <TabItem
                  key={item}
                  title={t(`common:${item}`)}
                  badges={
                    data?.data && data.data[item]
                      ? data.data[item].toString()
                      : ''
                  }
                >
                  <Stack.Item grow>
                    <BookingTemplate type={item} />
                  </Stack.Item>
                </TabItem>
              );
            })}
          </Tabs>
        </SectionContent>
      </Section>
    </>
  );
}
